// (function () {
// })();
window.sampleCollectionBundle = {
    state: {
         case_product: false,
         fragrance_limit: 30000,
         selected_fragrance: [],
         selected_case: []
     },
     selectors: {
         caseProduct: ".js-case-product",
         fragranceProduct: ".js-fragrance-handle",
         quantityBox: ".js-quantity",
         stickyCaseWrapper: ".js-selected-case-product-count",
         stickyFragranceWrapper: ".js-selected-fragrance-count",
         fragranceQuantityBtn: ".js-plus,.js-minus",
         caseQuantityBtn: '.js-case-minus,.js-case-plus',
         stickyBarFragranceRemoveBtn: ".js-fragrance-card-div",
         stickyBarCaseRemoveBtn: ".js-case-div",
         priceElement: ".js-price-elem",
         addToCartButton: ".js-add-to-cart",
         casePopupBtn: '.js-add-case-popup-btn',
         casePopupInner: '.js-case-product-model-main',
         casePopupCloseBtn: '.js-sample-model-close',
         casePopupExtraBtn: '.js-add-extra-case-popup-btn'
        

     },
     init() {
         this.caseProductInputs = document.querySelectorAll(this.selectors.caseProduct);
         this.fragranceProductInputs = document.querySelectorAll(this.selectors.fragranceProduct);
         this.quantityBoxElements = document.querySelectorAll(this.selectors.quantityBox);
         this.stickyCaseWrapper = document.querySelector(this.selectors.stickyCaseWrapper);
         this.stickyFragranceWrapper = document.querySelector(this.selectors.stickyFragranceWrapper);
         this.fragranceQuantityBtns = document.querySelectorAll(this.selectors.fragranceQuantityBtn);
         this.caseQuantityBtns = document.querySelectorAll(this.selectors.caseQuantityBtn);
         this.stickyBarFragranceRemoveBtns = document.querySelectorAll(this.selectors.stickyBarFragranceRemoveBtn);
         this.stickyBarCaseRemoveButton = document.querySelector(this.selectors.stickyBarCaseRemoveBtn);
         this.priceElement = document.querySelector(this.selectors.priceElement);
         this.addToCartButton = document.querySelector(this.selectors.addToCartButton);
         this.casePopupbtn = document.querySelector(this.selectors.casePopupBtn);
         this.casePopupInner = document.querySelector(this.selectors.casePopupInner);
         this.casePopupCloseBtn = document.querySelector(this.selectors.casePopupCloseBtn);
         this.casePopupExtraBtn = document.querySelector(this.selectors.casePopupExtraBtn);
         this.bindEvents();
     },
     bindEvents() {
         this.caseProductInputs.forEach((caseProductInput) => {
             if(caseProductInput.classList.contains("event-bind") === false){
                 caseProductInput.addEventListener("change", this.handleCaseProductInputChange.bind(this), true);
                 caseProductInput.classList.add("event-bind");
             }
         });
         this.fragranceProductInputs.forEach((fragranceProductInput) => {
             if(fragranceProductInput.classList.contains("event-bind") === false){
                 fragranceProductInput.addEventListener("change", this.handleFragranceProductInputChange.bind(this), true);
                 fragranceProductInput.classList.add("event-bind");
             }
         });
         this.fragranceQuantityBtns.forEach((fragranceQuantityBtn) => {
             if(fragranceQuantityBtn.classList.contains("event-bind") === false){
                 fragranceQuantityBtn.addEventListener("click", this.handleFragranceQtyChange.bind(this), true);
                 fragranceQuantityBtn.classList.add("event-bind");
             }
         });
       this.caseQuantityBtns.forEach((caseQuantityBtn) => {
             if(caseQuantityBtn.classList.contains("event-bind") === false){
                 caseQuantityBtn.addEventListener("click", this.handleCaseQtyChange.bind(this), true);
                 caseQuantityBtn.classList.add("event-bind");
             }
         });
         if(this.addToCartButton.classList.contains("event-bind") === false){
             this.addToCartButton.addEventListener("click", this.handleAddToCart.bind(this), true);
             this.addToCartButton.classList.add("event-bind");
         }
       if(this.casePopupbtn.classList.contains("event-bind") === false){
             this.casePopupbtn.addEventListener("click", this.handleCasePopupOpen.bind(this), true);
             this.casePopupbtn.classList.add("event-bind");
         }
       if(this.casePopupCloseBtn.classList.contains("event-bind") === false){
             this.casePopupCloseBtn.addEventListener("click", this.handleCasePopupClose.bind(this), true);
             this.casePopupCloseBtn.classList.add("event-bind");
         }
       if(this.casePopupExtraBtn.classList.contains("event-bind") === false){
             this.casePopupExtraBtn.addEventListener("click", this.handleCasePopupOpen.bind(this), true);
             this.casePopupExtraBtn.classList.add("event-bind");
         }
       if(document.querySelector(".js-view-selected-option").classList.contains("event-bind") === false){
          document.querySelector(".js-view-selected-option").addEventListener("click", this.handleViewSelectedOption.bind(this), true);
         document.querySelector(".js-view-selected-option").classList.add("event-bind");
       }
       
        
       
        if(document.querySelector('.js-overlay').classList.contains("event-bind") === false){
          document.querySelector('.js-overlay').addEventListener("click", this.handleCasePopupClose.bind(this), true);
         document.querySelector('.js-overlay').classList.add("event-bind");
       }
       
         this.onLoadFunction();
     },
     onLoadFunction(){
         const currentLength = this.state.selected_fragrance.reduce((acc, curr) => {
             return acc + parseInt(curr.quantity);
         }, 0);
       console.log("helloooooooooooooooo",currentLength)
         // if(currentLength === 4){
         //     this.fragranceProductInputs.forEach((fragranceProductInput) => {
         //         fragranceProductInput.setAttribute("disabled", true);
                 
         //     });
         // }
         // this.fragranceProductInputs.forEach((fragranceProductInput) => {
         //     if(fragranceProductInput.checked === true){
         //         fragranceProductInput.removeAttribute("disabled");
 
         //     }
             
         // });
         
         // this.caseProductInputs.forEach((caseProductInput)=>{
         //     if(parseInt(caseProductInput.getAttribute("data-product-size")) === this.state.fragrance_limit){
         //         caseProductInput.click();
         //     }
         // })
       this.renderCase();
       this.renderFragrance();
     },
     handleViewSelectedOption (e){
         document.querySelector(".js-sticky-main").classList.toggle("active");
         document.querySelector("body").classList.toggle("sticky-bar");
         e.target.closest(".js-view-selected-option").querySelector(".js-view").classList.toggle("hidden",e.target.classList.contains("js-hide") == false);
         e.target.closest(".js-view-selected-option").querySelector(".js-hide").classList.toggle("hidden",e.target.classList.contains("js-view") == false);
      },
    handleCasePopupOpen (e){
      const overlay = document.querySelector('.js-overlay');
      this.casePopupInner.classList.remove("hidden");
      document.querySelector("body").classList.add("sample-product-popup");
       overlay.classList.remove('active');
    },
    handleCasePopupClose (e) {
      console.log(e)
      const overlay = document.querySelector('.js-overlay');
      this.casePopupInner.classList.add("hidden");
      document.querySelector("body").classList.remove("sample-product-popup");
       overlay.classList.remove('active');
    },
     handleCaseProductInputChange(event) {
         const target = event.currentTarget;
         const handle = target.getAttribute("data-handle");
        
         // this.state.case_product = { handle, id, price, title, image };
       const quantityBox = target.closest(".js-input-label").querySelector(this.selectors.quantityBox);
      
         const quantityInput = quantityBox.querySelector("input");
       console.log(quantityInput);
         quantityBox.classList.toggle("hidden", !target.checked);
          if (target.checked) {
             const id = target.getAttribute("data-variant-id");
             const price = target.getAttribute("data-price");
             const image = target.getAttribute("data-image");
             const title = target.getAttribute("data-title");
             this.state.selected_case.push({ handle, id, price, title, image, quantity: 1 });
             quantityInput.value = 1;
         } else {
             this.state.selected_case = this.state.selected_case.filter((fragrance) => fragrance.handle !== handle);
             quantityInput.value = 0;
         }
         this.addToCartButton.hasAttribute("disabled")? this.addToCartButton.removeAttribute("disabled"): '';
         this.updatePrice();
         this.renderCase();
     },
     handleFragranceProductInputChange(event) {
         const target = event.currentTarget;
         const quantityBox = target.closest(".js-input-label").querySelector(this.selectors.quantityBox);
         const quantityInput = quantityBox.querySelector("input");
         quantityBox.classList.toggle("hidden", !target.checked);
         const handle = target.getAttribute("data-handle");
         if (target.checked) {
             const id = target.getAttribute("data-variant-id");
             const price = target.getAttribute("data-price");
             const image = target.getAttribute("data-image");
             const title = target.getAttribute("data-title");
             this.state.selected_fragrance.push({ handle, id, price, title, image, quantity: 1 });
             quantityInput.value = 1;
         } else {
             this.state.selected_fragrance = this.state.selected_fragrance.filter((fragrance) => fragrance.handle !== handle);
             quantityInput.value = 0;
         }
       this.addToCartButton.hasAttribute("disabled")? this.addToCartButton.removeAttribute("disabled"): '';
         this.updatePrice();
         this.renderFragrance();
     },
     handleFragranceQtyChange(event) {
         const target = event.currentTarget;
         const opertor = target.getAttribute("name");
         const quantityBox = target.closest(this.selectors.quantityBox);
         const quantityInput = quantityBox.querySelector("input");
         const currentValue = parseInt(quantityInput.value);
         const { selected_fragrance, fragrance_limit } = this.state;
         let newValue = currentValue;
         const currentLength = selected_fragrance.reduce((acc, curr) => {
             return acc + parseInt(curr.quantity);
         }, 0);
         const fragranceInput = target.closest(".product-details-main").querySelector(this.selectors.fragranceProduct);
         const handle = fragranceInput.getAttribute("data-handle");
         if (opertor === 'plus') {
             if (currentLength < fragrance_limit) {
                 newValue = currentValue + 1;
                 const fragranceIndex = selected_fragrance.findIndex((fragrance) => fragrance.handle === handle);
                 selected_fragrance[fragranceIndex] = { ...selected_fragrance[fragranceIndex], quantity: newValue };
             }
         } else {
             newValue = currentValue - 1;
             if (newValue > 0) {
                 const fragranceIndex = selected_fragrance.findIndex((fragrance) => fragrance.handle === handle);
                 selected_fragrance[fragranceIndex] = { ...selected_fragrance[fragranceIndex], quantity: newValue };

             } else {
                 fragranceInput.click();
             }
         }
         quantityInput.value = newValue;
         this.updatePrice();
         this.renderFragrance();
     },
     handleCaseQtyChange(event) {
         const target = event.currentTarget;
         const opertor = target.getAttribute("name");
         const quantityBox = target.closest(this.selectors.quantityBox);
         const quantityInput = quantityBox.querySelector("input");
         const currentValue = parseInt(quantityInput.value);
         const { selected_case, fragrance_limit } = this.state;
         let newValue = currentValue;
         const currentLength = selected_case.reduce((acc, curr) => {
             return acc + parseInt(curr.quantity);
         }, 0);
         const fragranceInput = target.closest(".product-details-main").querySelector(this.selectors.caseProduct);
         const handle = fragranceInput.getAttribute("data-handle");
         if (opertor === 'plus') {
             if (currentLength < fragrance_limit) {
                 newValue = currentValue + 1;
                 const fragranceIndex = selected_case.findIndex((fragrance) => fragrance.handle === handle);
                 selected_case[fragranceIndex] = { ...selected_case[fragranceIndex], quantity: newValue };
             }
         } else {
             newValue = currentValue - 1;
             if (newValue > 0) {
                 const fragranceIndex = selected_case.findIndex((fragrance) => fragrance.handle === handle);
                 selected_case[fragranceIndex] = { ...selected_case[fragranceIndex], quantity: newValue };

             } else {
                 fragranceInput.click();
             }
         }
  
         quantityInput.value = newValue;
         this.updatePrice();
         this.renderCase();
     },
     handleFragranceProductRemove(event){
         // console.log("callled")
         const target = event.currentTarget;
         const handle = target.getAttribute("data-handle");
         const quantityBoxes = document.querySelectorAll(this.selectors.quantityBox);
         let currentValue ;
         const quantityValue = quantityBoxes.forEach((quantityBox) => {
             if(quantityBox.getAttribute("data-handle")=== handle){
                 const quantityInput = quantityBox.querySelector("input");
                 currentValue = parseInt(quantityInput.value);
             }
         });
         const { selected_fragrance, fragrance_limit } = this.state;
         let newValue = currentValue;
         newValue = currentValue - 1;
         if (newValue > 0) {
             const fragranceIndex = selected_fragrance.findIndex((fragrance) => fragrance.handle === handle);
             selected_fragrance[fragranceIndex] = { ...selected_fragrance[fragranceIndex], quantity: newValue };

         } else {
             const fragranceInputs = document.querySelectorAll(this.selectors.fragranceProduct);
             fragranceInputs.forEach((fragranceInput)=>{
                 if(fragranceInput.getAttribute("data-handle")=== handle){ 
                     fragranceInput.click();
                 }
             })
         }
         quantityBoxes.forEach((quantityBox) => {
             if(quantityBox.getAttribute("data-handle")=== handle){
                 const quantityInput = quantityBox.querySelector("input");
                 quantityInput.value = newValue;
             }
         });
         this.updatePrice();
         this.renderFragrance();
         
     },
     handleCaseProductRemove(event){
        const target = event.currentTarget;
         const handle = target.getAttribute("data-handle");
         const quantityBoxes = document.querySelectorAll(this.selectors.quantityBox);
         let currentValue ;
         const quantityValue = quantityBoxes.forEach((quantityBox) => {
             if(quantityBox.getAttribute("data-handle")=== handle){
                 const quantityInput = quantityBox.querySelector("input");
                 currentValue = parseInt(quantityInput.value);
             }
         });
         const { selected_case, fragrance_limit } = this.state;
         let newValue = currentValue;
         newValue = currentValue - 1;
         if (newValue > 0) {
             const fragranceIndex = selected_case.findIndex((fragrance) => fragrance.handle === handle);
             selected_case[fragranceIndex] = { ...selected_case[fragranceIndex], quantity: newValue };

         } else {
             const fragranceInputs = document.querySelectorAll(this.selectors.fragranceProduct);
             fragranceInputs.forEach((fragranceInput)=>{
                 if(fragranceInput.getAttribute("data-handle")=== handle){ 
                     fragranceInput.click();
                 }
             })
         }
         quantityBoxes.forEach((quantityBox) => {
             if(quantityBox.getAttribute("data-handle")=== handle){
                 const quantityInput = quantityBox.querySelector("input");
                 quantityInput.value = newValue;
             }
         });
         this.updatePrice();
         this.renderCase();
     },
     updatePrice() {
         const { selected_case } = this.state;
         const { selected_fragrance, fragrance_limit } = this.state;
         let price = 0;
         for (let fragrance of selected_fragrance) {
             if(fragrance.quantity > 1){
                 price = price + parseInt((fragrance.price) * fragrance.quantity) ;
             }else{
                 price = price + parseInt(fragrance.price);
             }
         }
       for (let caseProduct of selected_case) {
             if(caseProduct.quantity > 1){
                 price = price + parseInt((caseProduct.price) * caseProduct.quantity) ;
             }else{
                 price = price + parseInt(caseProduct.price);
             }
         }
         this.priceElement.innerHTML = Shopify.formatMoney(price);
     },
     
     renderCase() {
         const { selected_case, fragrance_limit } = this.state;
         let difference = selected_case.length;
         // console.log(difference)
         this.stickyCaseWrapper.innerHTML = '0 Case product selected';
         let fragranceHtml;
         const currentLength = selected_case.reduce((acc, curr) => {
             return acc + parseInt(curr.quantity);
         }, 0);
       console.log(currentLength)
         for (let fragrance of selected_case) {
             const { handle, id, price, title, image, quantity } = fragrance;
             let fragrancePrice = Shopify.formatMoney(price)
             for (let i = 0; i < quantity; i++) {

                 let stringsToReplaceWith = { ProductTitle: title, ProductImage: image, ProductPrice: fragrancePrice, ProductHandle: handle, ProductQuantity: quantity }

                document.querySelectorAll(".js-case-product").forEach((input) => {
                  if(input.getAttribute("name") == handle){
                    input.checked = true;
                    input.closest(".js-input-label").querySelector(".js-quantity").classList.remove("hidden");
                   input.closest(".js-input-label").querySelector(".js-quantity").querySelector("input").value = quantity;
                  }
                })
             }
         }
         this.stickyCaseWrapper.innerText =  `${currentLength} Case product selected`;
        
     },
     renderFragrance() {
         const { selected_fragrance, fragrance_limit } = this.state;
         let difference = selected_fragrance.length;
         // console.log(difference)
         this.stickyFragranceWrapper.innerHTML = '0 Fragrances product selected';
         let fragranceHtml;
         const currentLength = selected_fragrance.reduce((acc, curr) => {
             return acc + parseInt(curr.quantity);
         }, 0);
       console.log(currentLength,"currentLength")
         for (let fragrance of selected_fragrance) {
             const { handle, id, price, title, image, quantity } = fragrance;
             let fragrancePrice = Shopify.formatMoney(price)
             for (let i = 0; i < quantity; i++) {
                  
                 let stringsToReplaceWith = { ProductTitle: title, ProductImage: image, ProductPrice: fragrancePrice, ProductHandle: handle, ProductQuantity: quantity }
                 document.querySelectorAll(".js-fragrance-handle").forEach((input) => {
                  if(input.getAttribute("name") == handle){
                    input.checked = true;
                    input.closest(".js-input-label").querySelector(".js-quantity").classList.remove("hidden");
                   input.closest(".js-input-label").querySelector(".js-quantity").querySelector("input").value = quantity;
                  }
                })
                
             }
         }
        this.stickyFragranceWrapper.innerText =  `${currentLength} Fragrances product selected`;
        
     },
    
    
     handleAddToCart(event){
         const { case_product } = this.state;
         const { selected_fragrance, fragrance_limit, selected_case } = this.state;
         const target = event.currentTarget;
         const uniqueBundleId = (Date.now()).toString();
         let items = [];
         
         target.innerHTML = 'Adding To Bag';
         target.setAttribute("disabled", true);
         
         for(let fragrance of selected_fragrance){
             let tempObject = {};
             tempObject.id = fragrance.id;
             tempObject.quantity = fragrance.quantity;
             tempObject.properties = {'fragrance_sample_product': true}
             items.push(tempObject);
         
         }
       for(let fragrance of selected_case){
             let tempObject = {};
             tempObject.id = fragrance.id;
             tempObject.quantity = fragrance.quantity;
             tempObject.properties = {'case_sample_product': true}
             items.push(tempObject);
         
         }
         
         let itemsObject = { items: items };
         fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify(itemsObject) })
             .then(response => (Promise.all([response, fetch(`${window.Shopify.routes.root}cart.js`, { method: 'GET' }),])))
             .then(([response1, response2]) => Promise.all([response1.json(), response2.json()]))
             .then(([response, cart]) => {
                 if (response.status) {
                     console.error("Product cannot be added", response);
                     return;
                 }else{
                     setTimeout(() => {
                         // Uncomment to redirect the user to the cart
                         window.location.href = window.Shopify.routes.root + 'cart';
                     }, 1500);
                 }
             });
     }
 }
window.sampleCollectionBundle.init();